import { Component, OnInit } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTableQueryParams } from 'ng-zorro-antd/table';

@Component({
  selector: 'app-cancelled-reviews',
  templateUrl: './cancelled-reviews.component.html',
  styleUrl: './cancelled-reviews.component.css',
})
export class CancelledReviewsComponent implements OnInit {
  cancelledReviews: any[] = [];
  isModalVisible = false;
  selectedOrder: any = null;
  isLoading = false;
  noteModal = false;
  note = '';
  currentUser: any;

  constructor(private dataService: DataserviceService, private message: NzMessageService) {}

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    this.loadCancelledReviews();
  }

  loadCancelledReviews() {
    this.isLoading = true;
    this.dataService.getData('work-order/eligibility')
      .subscribe((res: any) => {
        if (res.result === 'success') {
          this.cancelledReviews = res.data;
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.message.error('Failed to load cancelled reviews');
        }
      })
  }

  showResolveModal(order: any){
    this.selectedOrder = order;
    this.isModalVisible = true;
  }

  complete(){
    this.isLoading = true;
    this.dataService.postData(this.selectedOrder.id, 'work-order/update-eligibility')
      .subscribe((res: any) => {
        if (res.result === 'success') {
          this.message.success('Review has been completed');
          this.loadCancelledReviews();
          this.isModalVisible = false;
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.message.error('Failed to complete review');
        }
      }), (error: any) => {
        this.isLoading = false;
        this.message.error('Failed to complete review');
      }
  }

  handleCancel(){
    this.isModalVisible = false;
    this.selectedOrder = null;
  }


  submit(){
    this.isLoading = true;
    this.dataService.postData(this.selectedOrder.id, 'work-order/submit-update-eligibility')
      .subscribe((res: any) => {
        if (res.result === 'success') {
          this.message.success('Review has been completed');
          this.loadCancelledReviews();
          this.isModalVisible = false;
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.message.error('Failed to complete review');
        }
      }), (error: any) => {
        this.isLoading = false;
        this.message.error('Failed to complete review');
      }
    }

    // showNoteModal() {
    //   this.noteModal = true;
    // }

    // handleOkNote(){
    //   if(this.note == ''){
    //     alert('Please Add A Note');
    //   } else {
    //     this.isLoading = true;
    //     if(this.selectedOrder.eligibility_notes != null){
    //       this.selectedOrder.eligibility_notes.push({ text: this.note, date_created: new Date(), user_id: this.currentUser.id, user_first: this.currentUser.first_name, user_last: this.currentUser.last_name });
    //     } else {
    //       this.selectedOrder.eligibility_notes = [{ text: this.note, date_created: new Date(), user_id: this.currentUser.id, user_first: this.currentUser.first_name, user_last: this.currentUser.last_name }];
    //     }
    //     const obj = { id: this.selectedOrder.id, note: this.selectedOrder.eligibility_notes };
    //     this.dataService.postData(obj, 'customers/eligibility-note').subscribe((res: any) => {
    //       if (res.result === 'success') {
    //         this.message.success('Note Added!');
    //         // this.loadCancelledReviews();
    //         this.noteModal = false;
    //         this.isLoading = false;
    //         this.note = '';
    //       } else {
    //         this.isLoading = false;
    //         this.message.error('Failed to add note');
    //       }
    //     }), (error: any) => {
    //       this.isLoading = false;
    //       this.message.error('Failed to add note');
    //     }
    //   }
    // }
  
    // handleCancelNote(){
    //   this.note = '';
    //   this.noteModal = false;
    // }

    onQueryParamsChange(params: NzTableQueryParams): void {
      const { sort } = params;
      const currentSort = sort.find((s: any) => s.value !== null);
    
      if (currentSort) {
        const { key, value } = currentSort;
        this.cancelledReviews = [...this.cancelledReviews].sort((a, b) => {
          let valA = a[key];
          let valB = b[key];
    
          if (key === 'customer_name') {
            valA = `${a.first_name} ${a.last_name}`;
            valB = `${b.first_name} ${b.last_name}`;
          }
    
          if (key === 'sale_date' || key === 'eligibility_status_submitted_date') {
            valA = new Date(a[key]);
            valB = new Date(b[key]);
          }
    
          if (typeof valA === 'string' && typeof valB === 'string') {
            return value === 'ascend' ? valA.localeCompare(valB) : valB.localeCompare(valA);
          }
    
          return value === 'ascend' ? valA - valB : valB - valA;
        });
      }
    }
  }
